<template>
<div class="relative">
  <div class="relative overflow-hidden">
    <div class="h-[500px] bg-mk-light-blue "></div>
    <img src="/images/marketplace/landing_image.png"  
         alt="Welcome Image"
         class="h-[550px] hidden xl:block absolute top-[50px] right-[10%]"
    ></img>
    <div  style="background-image: linear-gradient(rgba(0, 0, 0, 0), rgb(255, 255, 255))"
          class="h-[500px] w-full absolute top-0"></div>
  </div>
  <div class="absolute top-0 pt-[100px] xl:pt-[160px] px-4 xl:pl-[15%] xl:pr-[40%] z-10 w-full">
    <div class="rounded-full overflow-hidden p-2 px-4 relative inline-flex items-center gap-2 mb-4">
      <div class="absolute top-0 left-0 w-full h-full bg-white opacity-60"></div>
      <div class="flex items-center z-10">
        <img src="/images/marketplace/flags/es.png" class="-ml-2">
        <img src="/images/marketplace/flags/it.png" class="-ml-2">
        <img src="/images/marketplace/flags/pt.png" class="-ml-2">
      </div>
      <span class="z-10 text-sm font-medium text-mk-black">{{ i18n.t('marketplace.welcome.p_1')  }}</span>
    </div> 
    <h1 class="text-xl xl:text-4xl font-bold text-mk-dark-blue mb-4">
      {{ i18n.t('marketplace.welcome.p_2')  }}
    </h1>
    <h3 class="text-sm xl:text-lg font-medium mb-4">
      {{ i18n.t('marketplace.welcome.p_3')  }}
    </h3>
    <SearchDestination />
  </div>
  <div class=" px-4 xl:px-[15%]  pt-8 pb-16">
    <!-- Nearby Rentals Section -->
    <template v-if="!geolocationDenied && !nearbyRentals.length && !loadingNearbyRentals">
      <div class="mb-10 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-6 border border-blue-100">
        <div class="flex flex-col xl:flex-row items-center justify-between gap-4">
          <div class="flex items-center gap-4">
            <div class="bg-blue-100 rounded-full p-3">
              <i class="bi bi-geo-alt text-blue-600 text-2xl"></i>
            </div>
            <div>
              <h3 class="text-lg font-semibold text-mk-dark-blue">{{ i18n.t('marketplace.welcome.nearby_rentals_title') }}</h3>
              <p class="text-sm text-gray-600">{{ i18n.t('marketplace.welcome.nearby_rentals_description') }}</p>
            </div>
          </div>
          <button
            @click="requestLocation"
            class="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors flex items-center gap-2 whitespace-nowrap"
          >
            <i class="bi bi-geo-alt-fill"></i>
            <span>{{ i18n.t('marketplace.welcome.show_nearby_locations') }}</span>
          </button>
        </div>
      </div>
    </template>

    <template v-if="loadingNearbyRentals">
      <div class="mb-10">
        <div class="flex items-center justify-between mb-6">
          <div class="h-7 w-48 bg-gray-200 rounded animate-pulse"></div>
        </div>
        <div class="-left-4 relative w-screen xl:left-0 xl:w-auto overflow-x-auto xl:overscroll-x-none">
          <div class="grid grid-cols-4 gap-4 mb-10 min-w-[calc(280px*4+16px*3)] xl:min-w-full px-4 xl:px-0">
            <div v-for="n in 4" :key="'skeleton-' + n" class="bg-white rounded-xl shadow-sm overflow-hidden">
              <!-- Skeleton Image -->
              <div class="w-full aspect-square bg-gray-200 animate-pulse"></div>
              <!-- Skeleton Content -->
              <div class="p-4">
                <div class="h-4 bg-gray-200 rounded animate-pulse mb-3"></div>
                <div class="h-3 bg-gray-200 rounded animate-pulse w-3/4 mb-3"></div>
                <div class="flex items-center justify-between mt-4">
                  <div class="h-5 bg-gray-200 rounded animate-pulse w-20"></div>
                  <div class="h-4 bg-gray-200 rounded-full animate-pulse w-16"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-if="nearbyRentals.length">
      <div class="flex items-center justify-between mb-6">
        <h3 class="text-xl font-semibold text-mk-dark-blue">
          {{ i18n.t('marketplace.welcome.nearby_rentals') }}
        </h3>
      </div>
      <div class="-left-4 relative w-screen xl:left-0 xl:w-auto overflow-x-auto xl:overscroll-x-none">
        <div class="grid grid-cols-4 gap-4 mb-10 min-w-[calc(280px*4+16px*3)] xl:min-w-full px-4 xl:px-0">
          <div v-for="item in nearbyRentals" :key="item.id" class="relative cursor-pointer" @click.prevent="goToItemPage(item)">
            <ItemCard :item="item" />
            <div class="bg-white rounded-lg px-2 py-1 absolute top-2 right-2 text-xs font-bold pointer-events-none">
              <i class="bi bi-geo-alt-fill text-blue-600 text-xs mr-1"></i>
              <span class="text-xs font-semibold text-gray-700">{{ item.attributes.distance }} km</span>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-if="itemsPreview.length">
      <div class="flex items-center justify-between mb-6">
        <h3 class="text-xl font-semibold text-mk-dark-blue">{{ i18n.t('marketplace.welcome.rentals_in')  }} {{ itemsPreview[0].attributes.location_name }}</h3>
        <a :href="`/marketplace/items?type=rentals&location_id=${itemsPreview[0].attributes.location_id}&location_name=${itemsPreview[0].attributes.location_name}`" class="text-sm text-mk-dark-blue hover:underline font-semibold">
          {{ i18n.t('marketplace.welcome.see_all')  }}
        </a>
      </div>
      <div class="-left-4 relative w-screen xl:left-0 xl:w-auto overflow-x-auto xl:overscroll-x-none">
        <div class="grid grid-cols-4 gap-4 mb-10 min-w-[calc(280px*4+16px*3)] xl:min-w-full px-4 xl:px-0">
          <ItemCard v-for="item in itemsPreview" :key="item.id" :item="item" />
        </div>
      </div>
    </template> 
    <template v-if="lessonsPreview.length">
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-xl font-semibold text-mk-dark-blue">{{ i18n.t('marketplace.welcome.experiences_in')  }} {{ lessonsPreview[0].attributes.location_name }}</h3>
        <a :href="`/marketplace/items?type=experiences&location_id=${lessonsPreview[0].attributes.location_id}&location_name=${lessonsPreview[0].attributes.location_name}`" class="text-sm text-mk-dark-blue hover:underline font-semibold">
          {{ i18n.t('marketplace.welcome.see_all')  }}
        </a>
      </div>
      <div class="-left-4 relative w-screen xl:left-0 xl:w-auto overflow-x-auto xl:overscroll-x-none">
        <div class="grid grid-cols-4 gap-4 mb-10 min-w-[calc(280px*4+16px*3)] xl:min-w-full px-4 xl:px-0">
          <ItemCard v-for="item in lessonsPreview" :key="item.id" :item="item" />
        </div>
      </div>
    </template>
  </div>
  <div class="px-4 xl:px-[15%] pb-16">
    <div class="flex items-center justify-between mb-6">
      <h3 class="text-xl font-semibold text-mk-dark-blue">{{ i18n.t('marketplace.welcome.destinations')  }}</h3>
      <a :href="`/marketplace/items?country_id=${selectedDestination}`" 
         class="text-sm text-mk-dark-blue hover:underline font-semibold">
        {{ i18n.t('marketplace.welcome.see_all')  }}
      </a>
    </div>
    <div class="inline-flex items-center rounded-lg bg-gray-100 gap-1 mb-4" >
      <div v-for="country in countries" :key="country.id" 
           @click="selectedDestination = country.id"
           class="flex items-center gap-1 py-1 px-2 cursor-pointer"
           :class="{'shadow rounded-lg bg-white': selectedDestination == country.id}"
      >
        <img v-if="country.attributes.flag" :src="country.attributes.flag" alt="Country Flag" class="max-w-[28px]">
        <span class="text-sm font-semibold text-gray-700 hidden xl:inline">{{ country.attributes.name }}</span>
      </div>
    </div>
    
    <div class="relative">
      <!-- Desktop navigation buttons -->
      <button 
        v-if="canScrollLeft"
        @click="scrollGallery('left')"
        class="hidden xl:flex absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white rounded-full shadow-lg w-10 h-10 items-center justify-center hover:bg-gray-50 transition-colors -ml-5"
      >
        <i class="bi bi-chevron-left text-xl"></i>
      </button>
      <button 
        v-if="canScrollRight"
        @click="scrollGallery('right')"
        class="hidden xl:flex absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white rounded-full shadow-lg w-10 h-10 items-center justify-center hover:bg-gray-50 transition-colors -mr-5"
      >
        <i class="bi bi-chevron-right text-xl"></i>
      </button>
      
      <div 
        ref="galleryScroll"
        @scroll="updateScrollButtons"
        class="overflow-x-auto overflow-y-hidden scroll-smooth -mx-4 px-4 xl:mx-0 xl:px-0 scrollbar-hide"
      >
        <div class="grid grid-flow-col auto-cols-[280px] xl:auto-cols-[minmax(280px,280px)] gap-3 xl:gap-4">
          <a 
            :href="`/marketplace/items?location_id=${destination.id}&location_name=${destination.attributes.name}`" 
            v-for="destination in limitedDestinations" 
            :key="destination.id" 
            class="bg-white relative rounded-xl overflow-hidden shadow-sm hover:shadow-md w-[280px] transition-shadow"
          >
            <img 
              v-if="destination.attributes.preview" 
              :src="destination.attributes.preview" 
              class="object-cover aspect-square w-full" 
            />
            <div v-else class="aspect-square w-full flex items-center justify-center bg-gray-100">
              <span class="fa-stack text-[72px] opacity-20">
                <i class="fa-image far fa-stack-1x" aria-hidden="true"></i>
                <i class="fa-slash fas icon-stack-base fa-stack-1x" aria-hidden="true"></i>
              </span>
            </div>
            <div class="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
            <div class="absolute bottom-0 left-0 p-3 xl:p-4 text-white">
              <h3 class="font-bold text-lg xl:text-xl">{{ destination.attributes.name }}</h3>
              <div class="text-xs xl:text-sm font-medium mt-1">
                {{ destination.attributes.offers }} {{ i18n.t('marketplace.welcome.offers')  }}
              </div>
            </div>
          </a>
        </div>
      </div>
      
      <!-- Mobile scroll indicators -->
      <div class="flex justify-center gap-1 mt-4 xl:hidden">
        <div 
          v-for="(destination, index) in limitedDestinations" 
          :key="'dot-' + destination.id"
          class="w-1.5 h-1.5 rounded-full transition-colors"
          :class="currentScrollIndex === index ? 'bg-mk-dark-blue' : 'bg-gray-300'"
        ></div>
      </div>
    </div>
  </div>
  <div class="px-[15%] pb-16">
    <div class="grid xl:grid-cols-2 gap-4">
      <div class="mb-6">
        <h3 class="font-bold text-xl">{{ i18n.t('marketplace.welcome.footer.title')  }}</h3>
        <p class="text-gray-700 mt-2">
          {{ i18n.t('marketplace.welcome.footer.subtitle')  }}
        </p>
      </div>
      <div>
        <div class="mb-12">
          <div class="p-2 rounded bg-gray-100 text-2xl mb-2 h-12 w-12 flex items-center justify-center">
            <i class="bi bi-cursor"></i>
          </div>
          <h4 class="font-bold text-lg mb-2">{{ i18n.t('marketplace.welcome.footer.p1')  }}</h4>
          <p class="text-gray-700 text-sm  mb-6">
            {{ i18n.t('marketplace.welcome.footer.pd1')  }}
          </p>
        </div>
         <div class="mb-12">
          <div class="p-2 rounded bg-gray-100 text-2xl mb-2 h-12 w-12 flex items-center justify-center">
            <i class="bi bi-sun"></i>
          </div>
          <h4 class="font-bold text-lg mb-2">{{ i18n.t('marketplace.welcome.footer.p2')  }}</h4>
          <p class="text-gray-700 text-sm  mb-6">
            {{ i18n.t('marketplace.welcome.footer.pd2')  }}
          </p>
        </div>
         <div class="mb-12">
          <div class="p-2 rounded bg-gray-100 text-2xl mb-2 h-12 w-12 flex items-center justify-center">
            <i class="far fa-handshake"></i>
          </div>
          <h4 class="font-bold text-lg mb-2">{{ i18n.t('marketplace.welcome.footer.p3')  }}</h4>
          <p class="text-gray-700 text-sm  mb-6">
            {{ i18n.t('marketplace.welcome.footer.pd3')  }}
          </p>
        </div>
         <div class="mb-12">
          <div class="p-2 rounded bg-gray-100 text-2xl mb-2 h-12 w-12 flex items-center justify-center">
            <i class="bi bi-calendar4"></i>
          </div>
          <h4 class="font-bold text-lg mb-2">{{ i18n.t('marketplace.welcome.footer.p4')  }}</h4>
          <p class="text-gray-700 text-sm  mb-6">
            {{ i18n.t('marketplace.welcome.footer.pd4')  }}
          </p>
        </div>
      </div>
    </div>
  </div>
  
  <!-- SEO Footer with Top Cities -->
  <div class="bg-gray-50 border-t border-gray-200 px-4 xl:px-[15%] py-12">
    <div class="mb-6">
      <p class="text-gray-600">{{ i18n.t('marketplace.welcome.explore_top_cities') }}</p>
    </div>
    
    <div v-if="topCities.length" class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3">
      <a 
        v-for="city in topCities" 
        :key="city.id"
        :href="`/marketplace/items?location_id=${city.id}&location_name=${city.name}`"
        class="group rounded-lg py-3"
      >
        <div class="flex items-start justify-between">
          <div class="flex-1 min-w-0">
            <h4 class="font-semibold text-mk-dark-blue group-hover:text-blue-600 transition-colors truncate">
              {{ city.name }}
            </h4>
            <p class="text-xs text-gray-500 truncate">{{ city.region }}</p>
          </div>
        </div>
      </a>
    </div>
    
    <div v-else class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3">
      <div v-for="n in 20" :key="'skeleton-city-' + n" class="bg-white rounded-lg px-4 py-3 border border-gray-100">
        <div class="h-5 bg-gray-200 rounded animate-pulse mb-2"></div>
        <div class="h-3 bg-gray-200 rounded animate-pulse w-2/3"></div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from '../../shared/custom_axios.js';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import ItemCard from '../items/card.vue';
import SearchDestination from './search_destination.vue';

export default {
  name: "WelcomeComponent",
  data() {
    return {
      itemsPreview: [],
      lessonsPreview: [],
      selectedDestination: null,
      countries: [],
      destinations: [],
      canScrollLeft: false,
      canScrollRight: false,
      currentScrollIndex: 0,
      nearbyRentals: [],
      loadingNearbyRentals: false,
      geolocationDenied: false,
      userLocation: null,
      topCities: []
    };
  },
  components: {
    DatePicker,
    ItemCard,
    SearchDestination
  },
  computed: {
    limitedDestinations() {
      return this.destinations.slice(0, 8);
    }
  },
  created() {
    this.loadPreviews();
    this.loadCountries();
    this.loadTopCities();
  },  
  watch: {
    selectedDestination() {
      this.loadDestinations();
    },
    destinations() {
      this.$nextTick(() => {
        this.updateScrollButtons();
      });
    }
  },
  mounted() {
    this.updateScrollButtons();
  },
  methods: {
    goToItemPage(item) {
      const params = new URLSearchParams();
      params.set('type', 'rentals');
      params.set('item_id', item.id);
      params.set('location_id', item.attributes.location_id);
      params.set('location_name', item.attributes.location_name);
      window.location.href = `/marketplace/items?${params}`;
    },
    requestLocation() {
      if (!navigator.geolocation) {
        alert(this.i18n.t('marketplace.welcome.geolocation_not_supported'));
        return;
      }

      this.loadingNearbyRentals = true;
      
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.userLocation = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          };
          this.loadNearbyRentals();
        },
        (error) => {
          this.loadingNearbyRentals = false;
          this.geolocationDenied = true;
          console.error('Geolocation error:', error);
        }
      );
    },
    loadNearbyRentals() {
      if (!this.userLocation) return;

      axios.get('/marketplace/nearby_rentals', {
        params: {
          latitude: this.userLocation.latitude,
          longitude: this.userLocation.longitude
        }
      })
        .then(response => {
          this.nearbyRentals = response.data.data;
        })
        .catch(error => {
          console.error('Error loading nearby rentals:', error);
        })
        .finally(() => {
          this.loadingNearbyRentals = false;
        });
    },
    loadPreviews() {
      axios.get('/marketplace/items_preview')
        .then(response => {
          this.itemsPreview = response.data.data;
        })
        .catch(error => {
          console.error('Error loading items preview:', error);
        });

      axios.get('/marketplace/lessons_preview')
        .then(response => {
          this.lessonsPreview = response.data.data;
        })
        .catch(error => {
          console.error('Error loading lessons preview:', error);
        });
    },
    loadCountries() {
      axios.get('/marketplace/countries')
        .then(response => {
          this.countries = response.data.data;
          this.selectedDestination = this.countries[0]?.id;
        })
        .catch(error => {
          console.error('Error loading countries:', error);
        });
    },
    loadDestinations() {
      axios.get('/marketplace/destinations', {
        params: {
          country_id: this.selectedDestination
        }
      })
        .then(response => {
          this.destinations = response.data.data;
        })
        .catch(error => {
          console.error('Error loading destinations:', error);
        });
    },
    loadTopCities() {
      axios.get('/marketplace/top_cities')
        .then(response => {
          this.topCities = response.data.data;
        })
        .catch(error => {
          console.error('Error loading top cities:', error);
        });
    },
    scrollGallery(direction) {
      const container = this.$refs.galleryScroll;
      if (!container) return;
      
      const scrollAmount = 296; // 280px card + 16px gap
      const targetScroll = direction === 'left' 
        ? container.scrollLeft - scrollAmount 
        : container.scrollLeft + scrollAmount;
      
      container.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });
    },
    updateScrollButtons() {
      const container = this.$refs.galleryScroll;
      if (!container) return;
      
      this.canScrollLeft = container.scrollLeft > 10;
      this.canScrollRight = container.scrollLeft < (container.scrollWidth - container.clientWidth - 10);
      
      // Update current scroll index for mobile dots
      const cardWidth = 296; // 280px card + 16px gap
      this.currentScrollIndex = Math.round(container.scrollLeft / cardWidth);
    }
  }
};
</script>
<style scoped>
/* Smooth scroll snap on mobile */
@media (max-width: 1279px) {
  .scrollbar-hide {
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
  }
  
  .scrollbar-hide > div > a {
    scroll-snap-align: start;
  }
}
</style>
